const optionTypes = {
  DIVIDER: 'divider',
  CUSTOM: 'custom',
  TOGGLE: 'toggle',
  SECTION: 'section',
  TOGGLEABLE_SECTION: 'toggleable-section',
  SLIDER: 'slider',
  COLOR_SCHEME: 'color-scheme',
  ACTION_RADIO_GROUP: 'action-radio-group',
  SELECT: 'select',
};

const decorativeOptionTypes = [optionTypes.DIVIDER];

export { decorativeOptionTypes };
export default optionTypes;
